module.exports = __webpack_public_path__ + "img/00899876-9ec8-4d7f-899b-bb9ff8f6ce9d.65c13c9a.png";